/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-up': {
    width: 42,
    height: 43,
    viewBox: '0 0 42 43',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M18.817 17.734a3 3 0 014.366 0l7.97 8.456a1 1 0 01-1.456 1.372l-7.969-8.456a1 1 0 00-1.456 0l-7.968 8.456a1 1 0 01-1.456-1.372l7.969-8.456z" _fill="#fff"/>'
  }
})
